__turbopack_context__.v({
  "cornerClose": "TasksClubOnlyDialog-module-scss-module__cmSUta__cornerClose",
  "cornerIcon": "TasksClubOnlyDialog-module-scss-module__cmSUta__cornerIcon",
  "description": "TasksClubOnlyDialog-module-scss-module__cmSUta__description",
  "dialog": "TasksClubOnlyDialog-module-scss-module__cmSUta__dialog",
  "glyph": "TasksClubOnlyDialog-module-scss-module__cmSUta__glyph",
  "inner": "TasksClubOnlyDialog-module-scss-module__cmSUta__inner",
  "primaryBtn": "TasksClubOnlyDialog-module-scss-module__cmSUta__primaryBtn",
  "title": "TasksClubOnlyDialog-module-scss-module__cmSUta__title",
});
